import { assign, groupBy } from 'lodash';
import { ActionType } from '../actions/actions';
import { IAction } from '../../classes/action';



export interface FindAPDSettingsModel {
    disclaimerLink: string;
    totalDentists: number;
    totalPages: number;
    countries: string[];
}

export const defaultFindAPDSettingsModel: FindAPDSettingsModel = {
    disclaimerLink: "",
    totalDentists: 0,
    totalPages: 0,
    countries: []
};

export default function findAPDSettingsReducer(state: FindAPDSettingsModel = defaultFindAPDSettingsModel, action: IAction) {
    switch (action.type) {
        case ActionType.REQUEST_SETTINGS: {
            return assign({}, state, { requestingSettings: true })
        }

        case ActionType.RECIEVE_SETTINGS: {
            const settings = action.value.findAPDSettings;
            const disclaimer = settings.disclaimerLink;
            const dentistsCount = settings.totalDentists;
            const pageCount = settings.totalPages;
            const countries = settings.countries;
            return assign({}, state, { requestingSettings: false, disclaimerLink: disclaimer, totalDentists: dentistsCount, totalPages: pageCount, countries: countries })
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/redux/reducers/find-a-pd-settings.ts